import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/umami"

// Trace une vue de page Umami nommée (ex. homeIndex_viewed), recalculée côté
// serveur depuis controller/action et fournie en valeur. connect() se redéclenche
// à chaque navigation Turbo. On ignore les rendus de prévisualisation Turbo (cache)
// pour ne pas double-compter une même vue.
//
// `props` (optionnel) : propriétés de l'évènement, ex. la surface d'une vue freemium
// (Dashboard::FreemiumViewTrackerComponent, #2559).
export default class extends Controller {
  static values = {
    name: String,
    props: { type: Object, default: {} }
  }

  connect() {
    if (!this.nameValue) return
    if (document.documentElement.hasAttribute("data-turbo-preview")) return

    track(this.nameValue, this.propsValue)
  }
}
